module.exports = __webpack_public_path__ + "media/images/city/073-democracy-monument-0a0055cac535e2e5460509424fd8bfee.svg";